export function VegMark({ flag, size = 14 }) {
  const color = flag === "veg" ? "#16A34A" : flag === "egg" ? "#EAB308" : "#DC2626";
  return (
    <span
      data-testid={`veg-mark-${flag}`}
      title={flag === "veg" ? "Veg" : flag === "egg" ? "Contains egg" : "Non-veg"}
      className="inline-grid shrink-0 place-items-center rounded-[3px] border-2 bg-white"
      style={{ borderColor: color, width: size, height: size }}
    >
      {flag === "non_veg" ? (
        <span style={{ width: 0, height: 0, borderLeft: `${size / 4}px solid transparent`, borderRight: `${size / 4}px solid transparent`, borderBottom: `${size / 2.4}px solid ${color}` }} />
      ) : (
        <span className="rounded-full" style={{ background: color, width: size / 2.3, height: size / 2.3 }} />
      )}
    </span>
  );
}

export const STATUS_LABEL = {
  created: "Placed", pending_payment: "Awaiting payment", paid: "Paid", accepted: "Accepted",
  in_kitchen: "In kitchen", ready: "Ready", served: "Served", cancelled: "Cancelled",
};
